import React from 'react'
import { feedbotToast } from '../toastDispatchers'

export const toastCopyOperationError = () => {
  const id = 'invalidCopyOperation'
  const title = 'Copy operation failed'
  const content = <>We encountered an error while trying to copy item.</>

  feedbotToast.error({ id, title, content })
}
